(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('mediaServerService', ['ajax', '$q', function (ajax, $q) {
            var mediaServerService = {};
            var servers = [];
            var mediaCoordinates = [];
            var userLatitude = '';
            var userLongitude = '';
            var distanceArray = [];
            var defaultServer;

            mediaServerService.getMediaServer = function () {
                const deferred = $q.defer();
                $q.all([
                    ajax.get('/api/mediaServer'),
                    ajax.get('/api/mediaServer/coordinates'),
                ]).then(function (data) {
                    data[0].servers.forEach((server) => {
                        if (server.default) {
                            defaultServer = server.host;
                        }
                        servers.push(server.host);
                        var arr = [server.lat, server.long];
                        mediaCoordinates.push(arr);
                    });
                    if (data[1] && data[1].long) {
                        userLatitude = data[1].lat;
                        userLongitude = data[1].long;
                        // call function to get distance from user to each server
                        mediaServerService.getDistanceFromServer();
                        // find minimum distance and return the server closest to the user
                        var minIndex = distanceArray.indexOf(Math.min.apply(null, distanceArray));
                        deferred.resolve(servers[minIndex]);
                    } else {
                        deferred.resolve(defaultServer);
                    }
                });

                return deferred.promise;
            };

            function degreesToRadians(degrees) {
                var pi = Math.PI;
                return degrees * (pi / 180);
            }

            mediaServerService.getDistanceFromServer = function () {
                mediaCoordinates.forEach((media) => {
                    var lat1 = degreesToRadians(userLatitude);
                    var lon1 = degreesToRadians(userLongitude);
                    var lat2 = degreesToRadians(media[0]);
                    var lon2 = degreesToRadians(media[1]);

                    // Haversine formula
                    /* eslint-disable no-restricted-properties */
                    var dlon = lon2 - lon1;
                    var dlat = lat2 - lat1;
                    var a = Math.sin(dlat / 2) ** 2
                            + Math.cos(lat1) * Math.cos(lat2)
                            * Math.sin(dlon / 2) ** 2;

                    var c = 2 * Math.asin(Math.sqrt(a));

                    // Radius of earth in kilometers.
                    var r = 6371;

                    // calculate the result
                    distanceArray.push(c * r);
                });
            };

            return mediaServerService;
        }]);
}());
